import { NextPage } from 'next';
import router from 'next/router';
import { useEffect } from 'react';
import { REDIRECT_PATH } from '@/common';
import { useUserContext } from '@/provider';

const Index: NextPage = () => {
  const { userInfo } = useUserContext();

  useEffect(() => {
    if (userInfo === undefined) {
      return;
    }
    router.replace(REDIRECT_PATH);
  }, [userInfo]);
  return null;
};

export default Index;
